import React, { useEffect, useState } from 'react';

export default function TableOfContents({ headings, children }) {
  const [active, setActive] = useState(null);

  useEffect(() => {
    if (!headings?.length) return;
    const els = headings.map((h) => document.getElementById(h.id)).filter(Boolean);
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.filter((e) => e.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (visible[0]) setActive(visible[0].target.id);
      },
      { rootMargin: '-100px 0px -65% 0px', threshold: 0 },
    );
    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [headings]);

  return (
    <aside className="docs-toc" aria-label="On this page">
      {headings?.length > 0 && (
        <>
          <div className="vt-eyebrow docs-toc-label">On this page</div>
          <nav>
            {headings.map((h) => (
              <a
                key={h.id}
                href={`#${h.id}`}
                className={`docs-toc-item${h.depth === 3 ? ' is-sub' : ''}${active === h.id ? ' is-active' : ''}`}
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById(h.id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  window.history.replaceState(null, '', `#${h.id}`);
                  setActive(h.id);
                }}
              >
                {h.text}
              </a>
            ))}
          </nav>
        </>
      )}
      {children}
    </aside>
  );
}
